export enum DeviationCheckVariable {
  Audit = 1,
  Board = 2,
  Ownership = 3,
  Compensation = 4,
  Family = 5,
  All = 6,
  PerDirector = 7
}
